<template>
    <ListView
        ref="list"
        title="Videos"
        :show-id="false"
        :api-paging="false"
        :api-search="false"
        :default-view="'grid'"
        use-folders
        :api-rename="require('@/common/api').default.avatarsJobsRename"
        :api-create-folder="require('@/common/api').default.avatarsCreateFolder"
        :api-list="require('@/common/api').default.avatarsJobs"
        :api-delete="require('@/common/api').default.avatarsJobsDelete"
        :columns="[
            { title: 'Name', name: 'name' }
        ]"
        :menu-items="menuItems">
        <template v-slot:top>
            <RouterLink to="create" class="btn btn-primary">
                <icon icon="plus" height="22" />
                Create Video
            </RouterLink>
        </template>
    </ListView>
    <folder-picker
        ref="folder-picker"
        :api-list="require('@/common/api').default.avatarsJobs"
        :columns="[
            { title: 'Name', name: 'name' }
        ]" />
</template>

<script>
import ListView from "@/views/templates/ListView.vue";
import api from "@/common/api";
import FolderPicker from "@/components/local/FolderPicker.vue";

export default {
    components: {
        FolderPicker,
        ListView
    },
    data() {
        return {
            loaded: false,
            menuItems: [
                { title: "Download", callback: this.downloadFile },
                { title: "Move", callback: this.moveItem }
            ],

            selectedFile: null
        };
    },
    methods: {
        downloadFile(file) {
            window.open(file.download_url);
        },
        moveItem(item) {
            this.$refs["folder-picker"].open((folder, close) => {
                close();
                api.avatarsJobsRename(item.id, item.name, folder).then(() => {
                    this.load();
                }).catch(e => {
                    this.flashError(e);
                });
            });
        },
        load() {
            this.$refs.list.load();
        }
    }
};
</script>
